var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("cupertino-alert-dialog", {
    attrs: {
      title: _vm.title,
      close: _vm.onClickOutSide,
      isError: _vm.isError,
      width: _vm.width,
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("div", {
              staticClass: "px-1 py-1 text-center",
              domProps: { innerHTML: _vm._s(_vm.content) },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "flex flex-row flex-center flex-spacearound" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full flex flex-center pointer py-1 hover bottom-radius-10 font-bold",
                    on: { click: _vm.onClickClose },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.close))])]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }